/**************************************************
 * Nombre:       Formulario_Soporte
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {Title} from "@mui/icons-material";
import {useEffect, useState} from "react";
import IngresoImagen from "../../Modulo_formularios/Componentes/IngresoImagen";
import Zoom from "react-medium-image-zoom";

const Formulario_Soporte = ({...props}) => {
    const [datos, setDatos] = useState({});


    useEffect(() => {

        let datos = props.props.getValues()
        if (datos) {
            setDatos(datos)
        }


    }, [props.props.watch])
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={12}>
                    <IngresoTexto Icono={Title} nombre={'Titulo'} dato={'nombre'} {...props}
                                  requerido={'Campo Requerido'}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={8} nombre={'Mensaje'} dato={'mensaje'} {...props}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Evidencias</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoImagen dato={'img'} {...props} ancho={1} alto={1}/>
                </Grid>


                {datos.id &&
                    <>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography>Respuesta del Admin</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}>
                            <IngresoTexto lineas={8} nombre={'Respuesta del Admin'} dato={'respuesta'} {...props}
                                          editable={false}

                            />
                        </Grid>

                        <Grid container size={12}>
                            <Zoom>
                                <img

                                    src={datos.img}
                                    width="100%"
                                />
                            </Zoom>
                        </Grid>

                    </>
                }


            </Grid>

        </form>

    )

}
export default Formulario_Soporte